import React from "react";
import { Share2 } from "lucide-react";
import { toast } from "sonner";

export const artShareUrl = (handle, id) => `${process.env.REACT_APP_BACKEND_URL}/api/share/art/${handle}/${id}`;

// Share one public piece: native share sheet on phones, copy link elsewhere. The link shows a preview image in chat and social apps.
export const ShareArtButton = ({ handle, it, accent }) => {
  if (!handle || !it?.id) return null;
  const share = async () => {
    const url = artShareUrl(handle, it.id);
    if (navigator.share) {
      try { await navigator.share({ title: it.title || "Artwork", url }); return; } catch (e) { if (e?.name === "AbortError") return; }
    }
    try { await navigator.clipboard.writeText(url); toast.success("Link copied, ready to paste anywhere"); }
    catch { window.prompt("Copy this link:", url); }
  };
  return (
    <button type="button" onClick={share} data-testid={`art-share-${it.id}`}
      className="inline-flex items-center gap-1.5 border border-white/15 text-zinc-300 px-3 py-1.5 font-body text-xs hover:bg-white/5 transition-colors" style={accent ? { borderColor: `${accent}66` } : undefined}>
      <Share2 size={13} /> Share this piece
    </button>
  );
};
